import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { TokenInterceptorService } from '../core/interceptors/token-interceptor.service';
import { AuthModule } from '../modules/auth/auth.module';
import { CartModule } from '../modules/cart/cart.module';
import { CollectionsModule } from '../modules/collections/collections.module';
import { DataPackModule } from '../modules/data-pack/data-pack.module';
import { LayoutsModule } from '../modules/layouts/layouts.module';
import { PagesModule } from '../modules/pages/pages.module';
import { ProductsModule } from '../modules/products/products.module';
import { SearchFilterModule } from '../modules/search-filter/search-filter.module';
import { SharedModule } from '../modules/shared/shared.module';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { I18N_PROVIDERS } from '../core/providers/i18next.provider';
import { I18NextModule } from 'angular-i18next';
import { CoreModule } from '../core/core.module';
import { StoreModule } from '@ngrx/store';
import { CartReducer } from '../modules/cart/store/reducers/cart.reducer';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { FilterReducer } from '../modules/search-filter/store/reducers/filter.reducer';
import { CollectionsFilterReducer } from '../modules/collections/store/reducers/collections-filter.reducer';
import { DataService, initializeApp } from '../core/services/data.service';
import { registerLocaleData } from '@angular/common';

// Registrierung der verschiedenen Sprachen. Wird für die Ausgabe der richtigen Währungszeichen gebraucht
import localeDe from '@angular/common/locales/de';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import localeNl from '@angular/common/locales/nl';
import localeIt from '@angular/common/locales/it';
import localeEs from '@angular/common/locales/es';
import { EffectsModule } from '@ngrx/effects';
import { AnalyticsEffects } from 'src/core/services/analytics.effects';
import { LightboxModule } from 'ngx-lightbox';
import { AuthStateService } from 'src/core/services/authstate.service';

registerLocaleData(localeDe, 'de');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeNl, 'nl');
registerLocaleData(localeIt, 'it');
registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    ProductsModule,
    CollectionsModule,
    SearchFilterModule,
    CartModule,
    AuthModule,
    BrowserModule,
    BrowserAnimationsModule,
    LayoutsModule,
    SharedModule,
    PagesModule,
    DataPackModule,
    CoreModule,
    StoreModule.forRoot({
      cart: CartReducer,
      filter: FilterReducer,
      collectionsFilter: CollectionsFilterReducer,
    }),
    I18NextModule.forRoot(),
    NgxSliderModule,
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: true }),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      enableHtml: true,
    }),
    HttpClientModule,
    EffectsModule.forRoot([AnalyticsEffects]),
    LightboxModule,
  ],
  providers: [
    I18N_PROVIDERS,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    DataService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [DataService],
      multi: true,
    },
    AuthStateService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
